<template>
  <div class="md-layout-item s1-U__width--180px">
    <md-card class="s1-U__full-height s1-U__border-radius--5px-force" md-with-hover>
      <div @click="redirect" class="s1-U__pd--tp32 s1-U__pd--bt32 s1-U__pd--lt16 s1-U__pd--rt16 s1-U__text-align--center">
        <div class="s1-loc__shortcut-icon s1-U__pd16 s1-U__text-color--primary">
          <div class="s1-loc__shortcut-icon__circle"/>
          <md-icon class="md-size-2x md-primary">
            <span>{{ action.icon }}</span>
          </md-icon>
        </div>
        <p class="md-body-2 s1-U__mg--tp16 s1-U__text-color--primary">{{ $t(action.name) }}</p>
      </div>
    </md-card>
  </div>
</template>
<script>
export default {
  props: {
    action: Object
  },
  methods: {
    redirect() {
      if (this.action && this.action.route) {
        let preRoute = this.$store.state.i18n && this.$store.state.i18n.locale;
        if (preRoute && preRoute !== '') {
          preRoute = '/' + preRoute;
        }
        this.$router.push(`${preRoute}${this.action.route}`);
      }
    }
  }
}
</script>
<style lang="scss">
.s1-loc__shortcut-icon {
  position: relative;
  display: inline-block;
  &__circle {
    border-radius: 50%;
    transform: rotate(180deg);
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    transition: transform 375ms ease-in-out 0s;
    &::before {
      content: "";
      border: 2px solid;
      opacity: 0.2;
      top: 0;
      left: 0;
      position: absolute;
      bottom: 0;
      right: 0;
      border-radius: 50%;
    }
    &::after {
      content: "";
      position: absolute;
      top: -5px;
      left: 50%;
      transform: translateX(-50%) rotate(0);
      transform-origin: 50% 100%;
      border-bottom: 5px solid;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      opacity: 0.2;
    }
  }
  .md-card:hover &__circle {
    transform: rotate(45deg);
  }
}
</style>
